import React from 'react';

/** Padding + max width for hub admin pages (StoreHubShell has no Layout chrome). */
export default function StoreHubAdminChrome({ children }) {
  return (
    <div className="w-full max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-6 app-density min-w-0">
      {children}
    </div>
  );
}
